import { isNotDefined } from '@sgme/fp';
import classNames from 'classnames';
import { getIcon } from 'components/common-form/builder/form/node/field/LabelField/LabelField.helper';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip';
import type { LabelFieldData, LabelFieldMetadata } from 'models/forms/fields';
import { FC, useMemo } from 'react';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

export const LabelField: FC<ProductNodeBuilderProps> = ({ node: { id }, workspaceType }) => {
  const [value] = useData<Extract<LabelFieldData, string>>(id);
  const translationKey = useFieldTranslationKey(id);
  const fieldMetadata = useFieldMetadata<LabelFieldMetadata>(id);
  const { minWidth, maxWidth, hasIcon } = useMemo(() => {
    if (isNotDefined(fieldMetadata)) {
      return {};
    }
    const { minWidth, maxWidth, hasIcon } = fieldMetadata;
    return { minWidth, maxWidth, hasIcon };
  }, [fieldMetadata]);

  const icon = getIcon(id, value);
  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${translationKey}` as any}
      minWidth={minWidth}
      maxWidth={maxWidth}
    >
      <div className="d-flex">
        {hasIcon && <i className="icon icon-sm pe-2">{icon}</i>}
        <LabelWithTooltip
          label={value || ''}
          tooltip={value || ''}
          className={classNames(workspaceType === 'addonManagement' ? 'text-start' : '')}
        />
      </div>
    </BlockOrientationFormGroup>
  );
};

LabelField.displayName = 'LabelField';
